import { z } from 'zod';

/**
 * Período do financeiro: `month` (AAAA-MM) ou `year` (AAAA). Informe só um dos dois;
 * omitidos = mês atual (no fuso da empresa).
 */
export const financeMonthQuerySchema = z
  .object({
    month: z
      .string()
      .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Mês inválido (use AAAA-MM)')
      .optional(),
    year: z
      .string()
      .regex(/^\d{4}$/, 'Ano inválido (use AAAA)')
      .optional(),
  })
  .refine((q) => !(q.month && q.year), { message: 'Informe month ou year, não os dois', path: ['year'] });
export type FinanceMonthQuery = z.infer<typeof financeMonthQuerySchema>;
